const stats = [
  { value: "1200万+", label: "月度话题曝光" },
  { value: "分钟级", label: "热度滚动更新" },
  { value: "6 大", label: "热门栏目覆盖" },
  { value: "365 天", label: "全年不间断陪伴" },
];

const values = [
  { icon: "ri-eye-line", title: "客观呈现", text: "只做热度与话题的忠实搬运，把讨论最激烈的内容如实呈现在你面前。" },
  { icon: "ri-flashlight-fill", title: "追热要快", text: "分钟级追踪流量峰值，第一时间收录最新鲜的爆款事件，绝不让你错过热点。" },
  { icon: "ri-scales-3-line", title: "理性吃瓜", text: "提倡健康吃瓜、理性讨论，不放大对立，只还原事件本身的关注度与脉络。" },
  { icon: "ri-heart-3-line", title: "持续陪伴", text: "无论娱乐八卦还是民生暖闻，让这里成为你每天顺手一刷的瓜田信息入口。" },
];

const testimonials = [
  { text: "上班摸鱼刷这个榜太方便了，今天全网在聊啥一眼就知道，再也不用几个软件来回切。", name: "用户·小夏", role: "追剧爱好者" },
  { text: "周榜很适合周末补瓜，一周错过的大事件都能一口气看明白，节奏很舒服。", name: "用户·阿泽", role: "数码UP主" },
  { text: "栏目分类很贴心，我只关心娱乐八卦，切换过去全是感兴趣的，效率高多了。", name: "用户·林林", role: "娱乐编辑" },
  { text: "热度条很直观，哪个话题讨论最多一目了然，很适合快速判断风向。", name: "用户·大川", role: "营销从业者" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              <i className="ri-questionnaire-fill text-primary-600"></i>
              关于吃瓜精选
            </span>
            <h2 className="mt-2 font-display text-3xl md:text-4xl text-foreground-950 leading-snug">
              做你每天顺手一刷的
              <br className="hidden md:block" />
              <span className="text-primary-600">吃瓜精选热门榜</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              吃瓜精选是一个专注于聚合全网高话题度事件的榜单型内容站。我们相信，与其在信息洪流里疲于奔命，不如让一份清晰的热度清单帮你快速找到今天最值得关注的焦点——从娱乐八卦、影视综艺，到社会热点与生活趣闻，一榜尽览。
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              我们的目标很简单：用吃瓜精选热门榜与本周排行，让每一位用户都能省去翻找时间，轻松跟上全网的话题节奏。
            </p>

            <dl className="mt-8 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl bg-accent-100/60 px-4 py-4 text-center ring-1 ring-accent-200/50">
                  <dd className="font-display text-2xl md:text-3xl text-accent-800">{s.value}</dd>
                  <dt className="mt-1 text-xs text-foreground-600 whitespace-nowrap">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl bg-background-100 ring-1 ring-background-200 p-5 hover:bg-primary-50 hover:ring-primary-200 transition-colors">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 text-base font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-16 md:mt-20">
          <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
            <h2 className="font-display text-3xl text-foreground-950">大家怎么说</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">来自真实用户的吃瓜日常与口碑反馈</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl bg-background-100 ring-1 ring-background-200 p-5 flex flex-col">
                <div className="flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-secondary-900 text-sm font-bold">
                    {t.name.charAt(2)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}